import {Inject, Injectable} from "@angular/core";
import {
  ActivatedRouteSnapshot,
  CanActivate,
  CanActivateChild,
  Router,
  RouterStateSnapshot,
  UrlTree
} from "@angular/router";
import {AUTH_CONFIG, AuthConfig, AuthService} from "./auth.service";
import {Observable} from "rxjs";

@Injectable({
    providedIn: 'root'
})
export class NoAuthGuard implements CanActivate, CanActivateChild {

    constructor(private authService: AuthService, private router: Router, @Inject(AUTH_CONFIG) private authConfig: AuthConfig) {
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
        const authenticateUser = this.authService.hasAuthenticatedUser();
        if (!authenticateUser) {
            return true;
        } else {
            if (this.authConfig.notAuthenticatedRedirectRoute) {
                this.router.parseUrl(this.authConfig.notAuthenticatedRedirectRoute);
            }
            return false;
        }
    }

    canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
        return this.canActivate(childRoute, state);
    }

}
